import { useEffect, useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'

import { ButtonValue, ButtonValues, PadButton } from './PadButton'

interface ManualEntryProps {
  onSelect: (amount: string) => void
  errorMsg: string
}

export const ManualEntry = ({ onSelect, errorMsg }: ManualEntryProps) => {
  const [currentValue, setCurrentValue] = useState('')

  const handlePress = (value: ButtonValue) => {
    if ((currentValue === '0' || currentValue === '') && value === 0) {
      return
    }

    let newValue = ''
    if (typeof value === 'number') newValue = addNumberToRight(currentValue, value)
    if (value === 'Clear') newValue = ''
    if (value === 'Delete') newValue = removeNumberFromRight(currentValue)
    setCurrentValue(newValue)
    onSelect(newValue)
  }

  useEffect(() => {
    if (errorMsg.length) {
      setCurrentValue('')
      onSelect('0')
    }
  }, [errorMsg.length, onSelect])

  return (
    <View style={styles.container}>
      <View style={styles.numberContainer}>
        <Text style={styles.number}>{currentValue ? currentValue : '0'}</Text>
      </View>
      <View style={styles.pad}>
        {ButtonValues.map((value) => (
          <PadButton key={`pad-button-${value}`} text={value} onPress={handlePress} />
        ))}
      </View>
    </View>
  )
}

const addNumberToRight = (current: string, newNumber: number) => current.concat(newNumber.toString())

const removeNumberFromRight = (current: string) => {
  if (current === '' || current.length === 1) return ''
  return current.slice(0, -1)
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8
  },
  numberContainer: {
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderColor: 'black',
    borderWidth: 2,
    borderRadius: 4
  },
  number: {
    fontWeight: 'bold'
  },
  pad: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 4
  }
})
